import { Loader } from 'google-maps';
import env from './env';

export default new Loader(env('googleMapsApiKey'), {
  version: '3.46',
  libraries: ['geometry', 'places'],
  region: 'PL',
  language: 'pl',
});
